import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {Observer} from "mobx-react-lite";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ConfirmDeliveredDeliveryButtonProperties from './ConfirmDeliveredDeliveryButtonProperties';
import Link from '../../../ui_components/Link/Link';

const ConfirmDeliveredDeliveryButton: React.FC<ConfirmDeliveredDeliveryButtonProperties> = ({
                                                                                  onClick = () => {},
                                                                                  onSave = () => {},
                                                                                  showIcon = true,
                                                                                  showText = true,
                                                                                  disabled,
                                                                                  className = '',
                                                                                  deliveryPersonInfo,
                                                                                  onDeliveredDelivery,
                                                                                  rounded = false,
                                                                                  size = ButtonSize.DEFAULT,
                                                                                  type = ButtonType.DEFAULT
}) => {

    const i18n = useI18nContext();
    const confirm = useConfirmation();

    const handleOnclick = async () => {
        const success = await confirm(i18n.translate("CONFIRM_DELIVERED_CONFIRMATION"), '');
        if(success){
            onDeliveredDelivery(deliveryPersonInfo)
        }       
    }

    const text = i18n.translate("CONFIRM_DELIVERED");

/*     const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <CheckCircle/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <CheckCircle/> : <></>}
        />
    } */

    return <Observer>
        {() => (
            <>
                {/* <Btn/> */}
                <div><Link text={text} onClick={handleOnclick}></Link></div>
            </>
        )}
            
                
    </Observer>
}

export default ConfirmDeliveredDeliveryButton;
